// neo_cogym — API 클라이언트 (W8/W11)
// 세션 토큰을 localStorage 에 보관하고 Authorization 헤더로 첨부.
// API_BASE: Pages(다른 오리진) 배포 시 Worker 절대 URL. 동일 오리진(dev 프록시)이면 "".

const TOKEN_KEY = "neo_token";

export const API_BASE = (import.meta.env.VITE_API_BASE ?? "").replace(/\/$/, "");

/** 상대 경로(/api, /content)를 API_BASE 기준 절대 URL 로 */
export function apiUrl(path: string): string {
  return path.startsWith("/") ? `${API_BASE}${path}` : path;
}

export function getToken(): string | null {
  return typeof localStorage !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;
}
export function setToken(t: string | null): void {
  if (typeof localStorage === "undefined") return;
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

export class ApiError extends Error {
  constructor(public status: number, msg: string) {
    super(msg);
  }
}

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const token = getToken();
  const res = await fetch(apiUrl(path), {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(init.headers ?? {}),
    },
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new ApiError(res.status, body.error ?? `HTTP ${res.status}`);
  }
  return (await res.json()) as T;
}
